import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-close-modal',
  templateUrl: './confirm-close-modal.component.html',
  styleUrls: ['./confirm-close-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmCloseModalComponent {
  public header: string;
  public message: string;
  public confirmBtn: string;
  public closeBtn: string;
  public isCloseModal: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) data, private translate: TranslateService) {
    this.header = data.header;
    this.message = data.message;
    this.confirmBtn = data.confirmBtn;
    this.closeBtn = data.closeBtn;
    this.isCloseModal = data.isCloseModal;
  }

  public get getCloseBtnLabel(): string {
    if (this.isCloseModal) {
      return this.translate.instant('common.button.close');
    }

    return this.closeBtn ? this.closeBtn : this.translate.instant('common.label.no');
  }
}
